import permissions from 'constants/permissions';
import React, { useEffect, useState, useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { MenubarDemo } from 'components/menubar/MenubarDemo';
import { FormattedMessage } from 'react-intl';
import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';
import { urlApi } from 'constants/urlApi';
import queryString from 'query-string';
import Axios from 'axios';
import { useApp } from 'context/AppContext';
import { loading } from 'helpers/loading/Loading';
import { notification } from 'constants/notification';
import { io } from 'socket.io-client';
// import { useKeycloak } from '@react-keycloak/web';
import clientApi from 'api/clientApi';
import { AppTranslationsContext } from 'context/AppTranslationsContext';
import { selectAuth, selectUser } from 'app/slice/authSlice';
import { APP_ECONTRACT } from 'constants/global';
import { RequestSupportDialog } from 'features/request-support/components/RequestSupportDialog';
import MENU_CONFIG from 'constants/menuConfig';
import { useQuery } from '@tanstack/react-query';
import { ACTIVE_STATUS } from 'constants/status';
import configClientApi from 'api/client/configClientApi';

const windowEnvConfig = window['runConfig'];
const AppTopbar = ({ setHeight }) => {
    const contextLang = useContext(AppTranslationsContext);

    const { showAlert } = useApp();

    const userPer = useSelector(selectUser);

    // const { keycloak } = useKeycloak()
    const [visibleRight, setVisibleRight] = useState(false);
    const [packageType, setPackageType] = useState(null);
    const authData = useSelector(selectAuth);
    const [dataSocket, setDataSocket] = useState(null);

    const REACT_APP_SOCKET = windowEnvConfig.REACT_APP_SOCKET_URL;

    useEffect(() => {
        const objSocket = io(REACT_APP_SOCKET);
        if (userPer) {
            const arg = {
                uuid: userPer.data.uuid,
                keyword: 'ciphertext',
            };
            if (objSocket) objSocket.emit('cyber_sign_register_room', arg);
        }

        objSocket.on('cyber_sign_server_push_notify', handleInviteAccepted);

        // cleanup
        return () => {
            objSocket.off('cyber_sign_server_push_notify', handleInviteAccepted);
        };
        // eslint-disable-next-line
    }, [contextLang.locale, userPer]);

    const handleInviteAccepted = useCallback(
        (data) => {
            setDataSocket(data);
            let num_notify = data.length;
            if (num_notify > 0) {
                if (contextLang.locale === 'en') {
                    showAlert('success', 'Notification!', `You have ${num_notify} new notifications`);
                } else {
                    showAlert('success', 'Thông báo!', `Bạn có ${num_notify} thông báo mới`);
                }
            }
        },
        // eslint-disable-next-line
        [contextLang.locale]
    );

    const [visibleRequestSupport, setVisibleRequestSupport] = useState(false);
    const onHideDialogRequestSupport = () => {
        setVisibleRequestSupport(false);
    };

    const [listMenuConfig, setListMenuConfig] = useState([]);

    const resultMenuConfig = useQuery(['configApi-getAllMenuConfig'], async () => {
        return await configClientApi.getAllMenuConfig({ status: ACTIVE_STATUS });
    });

    const genDataMenuConfig = () => {
        try {
            if (resultMenuConfig.data) {
                const { data, status, message } = resultMenuConfig.data;
                if (status === 2) {
                    showAlert('error', notification.FAIL, message);
                    return;
                }
                if (status === 1) {
                    let arr = [];
                    data.forEach((element) => {
                        arr.push(element.name);
                    });
                    setListMenuConfig(arr);
                }
            }
        } catch (error) {
            console.error('error: ', error);
        }
    };
    useEffect(() => {
        genDataMenuConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resultMenuConfig.data, resultMenuConfig.isFetching]);

    const menuRequestSupport = {
        label: <FormattedMessage id="common.requestSupport" />,
        icon: 'pi pi-fw pi-question',
        command: () => {
            setVisibleRight(false);
            setVisibleRequestSupport(true);
        },
        permission: true,
        isShow: MENU_CONFIG.CRM_REQUEST_SUPPORT,
    };

    const NAV_LINK_CONSTANT = [
        {
            label: <FormattedMessage id="doc-topbar" />,
            icon: 'pi pi-fw pi-folder',
            permission: '',
            items: [
                {
                    label: <FormattedMessage id="submit-topbar" />,
                    icon: 'pi pi-fw pi-send',
                    permission: permissions.CRM_SUBMISSION_LIST,
                    link: routerMain.CATEGORY_SUBMISSION,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="approve-topbar" />,
                    icon: 'pi pi-fw pi-check-circle',
                    permission: permissions.CRM_SUBMISSION_CONFIRM_LIST,
                    link: routerMain.CATEGORY_SUBMISSION_CONFIRM,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="completed-topbar" />,
                    icon: 'pi pi-fw pi-check-square',
                    permission: permissions.CRM_SUBMISSION_CONFIRMED_LIST,
                    link: routerMain.CATEGORY_SUBMISSION_CONFIRMED,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="refused-topbar" />,
                    icon: 'pi pi-fw pi-ban',
                    permission: permissions.CRM_SUBMISSION_REFUSE_LIST,
                    link: routerMain.CATEGORY_SUBMISSION_REFUSE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="ReferenceTemplateText.title" />,
                    icon: 'pi pi-fw pi-book',
                    permission: permissions.CRM_REFERENCE_TEMPLATE_TEXT_LIST,
                    link: routerMain.REFERENCE_TEMPLATE_TEXT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="contract-manager-topbar" />,
            icon: 'pi pi-fw pi-tag',
            permission: '',
            className: `${userPer?.is_use_contract === 1 ? '' : 'p-d-none'}`,
            items: [
                {
                    label: <FormattedMessage id="contract-topbar" />,
                    icon: 'pi pi-fw pi-send',
                    permission: permissions.CRM_CATE_CONTRACT_LIST,
                    link: routerMain.CONTRACT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="contract-approve-topbar" />,
                    icon: 'pi pi-fw pi-check-circle',
                    permission: permissions.CRM_CATE_CONTRACT_CONFIRM_LIST,
                    link: routerMain.CONTRACT_CONFIRM,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="ContractDocument.top_bar.title" />,
                    icon: 'pi pi-fw pi-file',
                    permission: permissions.CRM_CONTRACT_DOC_LIST,
                    link: routerMain.CONTRACT_DOCUMENT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="ContractDocumentConfirm.top_bar.title" />,
                    icon: 'pi pi-fw pi-check-square',
                    permission: permissions.CRM_CONFIRM_CONTRACT_DOC_LIST,
                    link: routerMain.CONTRACT_DOCUMENT_CONFIRM,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="template-contract-topbar" />,
                    icon: 'pi pi-fw pi-inbox',
                    permission: permissions.CRM_CATE_CONTRACT_TYPE_LIST,
                    link: routerMain.CATEGORY_CONTRACT_TYPE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="ReferenceTemplateContract.title" />,
                    icon: 'pi pi-fw pi-book',
                    permission: permissions.CRM_REFERENCE_TEMPLATE_CONTRACT_LIST,
                    link: routerMain.REFERENCE_TEMPLATE_CONTRACT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="contract-complaints" />,
                    icon: 'pi pi-fw pi-exclamation-triangle',
                    permission: permissions.CRM_COMPLAINT_CONTRACT_LIST,
                    link: routerMain.CONTRACT_COMPLAINTS,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="archives-topbar" />,
            icon: 'pi pi-fw pi-file-o',
            permission: '',
            items: [
                {
                    label: <FormattedMessage id="personal-doc-topbar" />,
                    icon: 'pi pi-fw pi-file',
                    permission: permissions.CRM_PERSONAL_DOCUMENT_LIST,
                    link: `${routerMain.PERSONAL_DOCUMENT}${routerPathMain.MY_DOCUMENT}`,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="outgoing-topbar" />,
                    icon: 'pi pi-fw pi-sign-out',
                    permission: permissions.CRM_DOCUMENT_SENT_LIST,
                    link: routerMain.CATEGORY_DOCUMENT_SENT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="incoming-topbar" />,
                    icon: 'pi pi-fw pi-sign-in',
                    permission: permissions.CRM_DOCUMENT_COME_LIST,
                    link: routerMain.CATEGORY_DOCUMENT_INCOMING,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="sample-doc" />,
                    icon: 'pi pi-fw pi-folder-open',
                    permission: permissions.CRM_CATE_DOC_TEMPLATE_LIST,
                    link: routerMain.CATEGORY_DOCUMENT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="type-doc-topbar" />,
                    icon: 'pi pi-fw pi-inbox',
                    permission: permissions.CRM_CATE_DOC_TYPE_LIST,
                    link: routerMain.CATEGORY_DOCUMENT_TYPE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="organization" />,
            icon: 'pi pi-fw pi-briefcase',
            items: [
                {
                    label: <FormattedMessage id="partner-topbar" />,
                    icon: 'pi pi-fw pi-briefcase',
                    permission: permissions.CRM_CATE_PARTNER_LIST,
                    link: routerMain.PARTNER,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="processes-topbar" />,
                    icon: 'pi pi-fw pi-align-left',
                    permission: permissions.CRM_CATE_PROCEDURE_LIST,
                    link: routerMain.CATEGORY_PROCEDURE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="type-processes" />,
                    icon: 'pi pi-fw pi-align-justify',
                    permission: permissions.CRM_CATE_TYPE_PROCEDURE_LIST,
                    link: routerMain.CATEGORY_TYPE_PROCEDURE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="sample-sign-topbar" />,
                    icon: 'pi pi-fw pi-pencil',
                    permission: permissions.CRM_CATE_SIGN_TEMPLATE_LIST,
                    link: routerMain.SIGN_TEMPLATE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="setting-cts-topbar" />,
                    icon: 'pi pi-fw pi-key',
                    permission: permissions.CRM_CONFIG_CERT_LIST,
                    link: routerMain.CONFIG_DIGITAL_CERTIFICATE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="approve-group" />,
                    icon: 'pi pi-fw pi-users',
                    link: routerMain.APPROVAL_GROUP,
                    permission: permissions.CRM_CATE_APPROVAL_GROUP_LIST,
                },
                {
                    label: <FormattedMessage id="manage-organizationtree-topbar" />,
                    icon: 'pi pi-fw pi-sitemap',
                    permission: permissions.CRM_CATE_ORGANIZATION_TREE_LIST,
                    link: routerMain.ORGANIZATION_TREE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="manage-position-topbar" />,
                    icon: 'pi pi-fw pi-th-large',
                    permission: permissions.CRM_POSITION_LIST,
                    link: routerMain.CATEGORY_POSITION,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="AuthorityManager.authority_topbar" />,
                    icon: 'pi pi-fw pi-sort-alt',
                    permission: permissions.CRM_AUTHORITY_LIST,
                    link: routerMain.AUTHORITY_MANAGER,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="system-topbar" />,
            icon: 'pi pi-fw pi-desktop',
            items: [
                {
                    label: <FormattedMessage id="manage-user-topbar" />,
                    icon: 'pi pi-fw pi-users',
                    permission: permissions.CRM_USER_LIST,
                    link: routerMain.USER,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="manage-role-topbar" />,
                    icon: 'pi pi-fw pi-share-alt',
                    permission: permissions.CRM_ROLE_LIST,
                    link: routerMain.ROLE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="mail-history-topbar" />,
                    icon: 'pi pi-fw pi-clock',
                    permission: permissions.CRM_MAILING_HISTORY_LIST,
                    link: routerMain.MAILING_HISTORY,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="sample-email-topbar" />,
                    icon: 'pi pi-fw pi-envelope',
                    permission: permissions.CRM_CATE_MAIL_TEMPLATE_LIST,
                    link: routerMain.EMAIL_TEMPLATE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="system-setting-topbar" />,
                    icon: 'pi pi-fw pi-cog',
                    permission: permissions.CRM_SETTING_LIST,
                    link: routerMain.CONFIG,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="filestorage-setting-topbar" />,
                    icon: 'pi pi-fw pi-file',
                    permission: permissions.CRM_CONFIG_STORAGE_LIST,
                    link: routerMain.CONFIG_STORAGE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="report" />,
            icon: 'pi pi-fw pi-check-square',
            items: [
                {
                    label: <FormattedMessage id="synthesis_report" />,
                    icon: 'pi pi-fw pi-book',
                    permission: permissions.CRM_SYNTHESIS_REPORT,
                    link: routerMain.SYNTHESIS_REPORT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="support" />,
            icon: 'pi pi-fw pi-question-circle',
            items: [
                {
                    label: <FormattedMessage id="user-manual-topbar" />,
                    icon: 'pi pi-fw pi-book',
                    link: routerMain.USER_MANUAL,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="release_note" />,
                    icon: 'pi pi-fw pi-globe',
                    link: routerMain.RELEASE_NOTE,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="down-plugin-usb" />,
                    icon: 'pi pi-fw pi-download',
                    command: (e) => {
                        setVisibleRight(false);
                        downloadFile(e, 1);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="setup-wizard" />,
                    icon: 'pi pi-fw pi-cog',
                    link: routerMain.QUICK_WIZARD,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="quick-sign" />,
                    icon: 'pi pi-fw pi-pencil',
                    link: routerMain.SIGN_NUMBER,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="digital-sign-check" />,
                    icon: 'pi pi-fw pi-check',
                    link: routerMain.CHECK_SIGN,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                menuRequestSupport,
            ],
        },
    ];

    const NAV_ECONTRACT_LINK_CONSTANT = [
        {
            label: <FormattedMessage id="doc-topbar" />,
            icon: 'pi pi-fw pi-folder',
            permission: '',
            items: [
                {
                    label: <FormattedMessage id="submit-topbar" />,
                    icon: 'pi pi-fw pi-send',
                    permission: permissions.CRM_SUBMISSION_LIST,
                    link: routerMain.CATEGORY_SUBMISSION,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="approve-topbar" />,
                    icon: 'pi pi-fw pi-check-circle',
                    permission: permissions.CRM_SUBMISSION_CONFIRM_LIST,
                    link: routerMain.CATEGORY_SUBMISSION_CONFIRM,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="ReferenceTemplateText.title" />,
                    icon: 'pi pi-fw pi-book',
                    permission: permissions.CRM_REFERENCE_TEMPLATE_TEXT_LIST,
                    link: routerMain.REFERENCE_TEMPLATE_TEXT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="contract-manager-topbar" />,
            icon: 'pi pi-fw pi-tag',
            permission: '',
            className: `${userPer?.is_use_contract === 1 ? '' : 'p-d-none'}`,
            items: [
                {
                    label: <FormattedMessage id="contract-topbar" />,
                    icon: 'pi pi-fw pi-send',
                    permission: permissions.CRM_CATE_CONTRACT_LIST,
                    link: routerMain.CONTRACT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="contract-approve-topbar" />,
                    icon: 'pi pi-fw pi-check-circle',
                    permission: permissions.CRM_CATE_CONTRACT_CONFIRM_LIST,
                    link: routerMain.CONTRACT_CONFIRM,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="ReferenceTemplateContract.title" />,
                    icon: 'pi pi-fw pi-book',
                    permission: permissions.CRM_REFERENCE_TEMPLATE_CONTRACT_LIST,
                    link: routerMain.REFERENCE_TEMPLATE_CONTRACT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="organization" />,
            icon: 'pi pi-fw pi-briefcase',
            items: [
                {
                    label: <FormattedMessage id="manage-organizationtree-topbar" />,
                    icon: 'pi pi-fw pi-sitemap',
                    permission: permissions.CRM_CATE_ORGANIZATION_TREE_LIST,
                    link: routerMain.ORGANIZATION_TREE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="manage-role-topbar" />,
                    icon: 'pi pi-fw pi-share-alt',
                    permission: permissions.CRM_ROLE_LIST,
                    link: routerMain.ROLE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="manage-user-topbar" />,
                    icon: 'pi pi-fw pi-users',
                    permission: permissions.CRM_USER_LIST,
                    link: routerMain.USER,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="partner-topbar" />,
                    icon: 'pi pi-fw pi-briefcase',
                    permission: permissions.CRM_CATE_PARTNER_LIST,
                    link: routerMain.PARTNER,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="common.administration" />,
            icon: 'pi pi-fw pi-desktop',
            items: [
                {
                    label: <FormattedMessage id="common.signatureManagement" />,
                    icon: 'pi pi-fw pi-key',
                    items: [
                        {
                            label: <FormattedMessage id="sample-sign-topbar" />,
                            icon: 'pi pi-fw pi-pencil',
                            permission: permissions.CRM_CATE_SIGN_TEMPLATE_LIST,
                            link: routerMain.SIGN_TEMPLATE,
                            command: () => {
                                setVisibleRight(false);
                            },
                        },
                        {
                            label: <FormattedMessage id="setting-cts-topbar" />,
                            icon: 'pi pi-fw pi-key',
                            permission: permissions.CRM_CONFIG_CERT_LIST,
                            link: routerMain.CONFIG_DIGITAL_CERTIFICATE,
                            command: () => {
                                setVisibleRight(false);
                            },
                        },
                    ],
                },
                {
                    label: <FormattedMessage id="common.emailManagement" />,
                    icon: 'pi pi-fw pi-envelope',
                    items: [
                        {
                            label: <FormattedMessage id="sample-email-topbar" />,
                            icon: 'pi pi-fw pi-envelope',
                            permission: permissions.CRM_CATE_MAIL_TEMPLATE_LIST,
                            link: routerMain.EMAIL_TEMPLATE,
                            command: () => {
                                setVisibleRight(false);
                            },
                        },
                        {
                            label: <FormattedMessage id="mail-history-topbar" />,
                            icon: 'pi pi-fw pi-clock',
                            permission: permissions.CRM_MAILING_HISTORY_LIST,
                            link: routerMain.MAILING_HISTORY,
                            command: () => {
                                setVisibleRight(false);
                            },
                        },
                    ],
                },
                {
                    label: <FormattedMessage id="system-setting-topbar" />,
                    icon: 'pi pi-fw pi-cog',
                    permission: permissions.CRM_SETTING_LIST,
                    link: routerMain.CONFIG,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="filestorage-setting-topbar" />,
                    icon: 'pi pi-fw pi-file',
                    permission: permissions.CRM_CONFIG_STORAGE_LIST,
                    link: routerMain.CONFIG_STORAGE,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
                {
                    label: <FormattedMessage id="synthesis_report" />,
                    icon: 'pi pi-fw pi-book',
                    permission: permissions.CRM_SYNTHESIS_REPORT,
                    link: routerMain.SYNTHESIS_REPORT,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="utilities-topbar" />,
            icon: 'pi pi-fw pi-info-circle',
            items: [
                {
                    label: <FormattedMessage id="quick-sign" />,
                    icon: 'pi pi-fw pi-pencil',
                    link: routerMain.SIGN_NUMBER,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="digital-sign-check" />,
                    icon: 'pi pi-fw pi-check',
                    link: routerMain.CHECK_SIGN,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="personal-doc-topbar" />,
                    icon: 'pi pi-fw pi-file',
                    permission: permissions.CRM_PERSONAL_DOCUMENT_LIST,
                    link: `${routerMain.PERSONAL_DOCUMENT}${routerPathMain.MY_DOCUMENT}`,
                    command: () => {
                        setVisibleRight(false);
                    },
                },
            ],
        },
        {
            label: <FormattedMessage id="support" />,
            icon: 'pi pi-fw pi-question-circle',
            items: [
                {
                    label: <FormattedMessage id="user-manual-topbar" />,
                    icon: 'pi pi-fw pi-book',
                    link: routerMain.USER_MANUAL,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="release_note" />,
                    icon: 'pi pi-fw pi-globe',
                    link: routerMain.RELEASE_NOTE,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="down-plugin-usb" />,
                    icon: 'pi pi-fw pi-download',
                    command: (e) => {
                        setVisibleRight(false);
                        downloadFile(e, 1);
                    },
                    permission: true,
                },
                {
                    label: <FormattedMessage id="setup-wizard" />,
                    icon: 'pi pi-fw pi-cog',
                    link: routerMain.QUICK_WIZARD,
                    command: () => {
                        setVisibleRight(false);
                    },
                    permission: true,
                },
                menuRequestSupport,
            ],
        },
    ];
    const handlePackage = () => {
        if (userPer)
            switch (userPer.package_group) {
                case 1:
                    setPackageType('Registered Free');
                    break;
                case 2:
                    setPackageType('Starter');
                    break;
                case 3:
                    setPackageType('Basic');
                    break;
                case 4:
                    setPackageType('Advance');
                    break;
                case 5:
                    setPackageType('Premium');
                    break;
                default:
                    setPackageType('');
            }
    };

    const downloadFile = async (e, type) => {
        loading.runLoadingBlockUI();
        try {
            const BASE_URL = windowEnvConfig.REACT_APP_BASE_API_URL;
            let contentIframe = `${BASE_URL}${urlApi.URL_DOWNLOAD}?`;
            let stringApiIframe = {
                type,
            };

            const result = await clientApi.infoFileSoftware(stringApiIframe);
            if (result.status === 2) {
                showAlert('error', notification.FAIL, result.message);
                return;
            }

            const querryIframe = queryString.stringify(stringApiIframe);
            contentIframe += querryIframe;
            const url = contentIframe;

            Axios.get(`${url}`, {
                responseType: 'blob',
            })
                .then(function (response) {
                    const urlDownload = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = urlDownload;
                    link.download = result.data.file_name;
                    document.body.appendChild(link);
                    link.click();
                    loading.stopRunLoading();
                })
                .catch(function (error) {
                    loading.stopRunLoading();
                    console.error('error: ', error);
                    showAlert('error', notification.FAIL, notification.MESSAGE_ERROR);
                });
        } catch (error) {
            loading.stopRunLoading();
            console.error('error: ', error);
            showAlert('error', notification.FAIL, notification.MESSAGE_ERROR);
        }
    };

    const [menu, setMenu] = useState([]);
    const getMenu = () => {
        const mainNav = authData?.app === APP_ECONTRACT ? NAV_ECONTRACT_LINK_CONSTANT : NAV_LINK_CONSTANT;
        // const mainMenuSp = menuSupport;

        let listMenuAfterPermissionCheck = [];
        if (userPer) {
            mainNav.map((cate, i) => {
                if (cate.items) {
                    cate.items = cate.items.filter((item) => {
                        if (item.items && item.items.length !== 0) {
                            item.items = item.items.filter((value) => {
                                const isMenu = value.hasOwnProperty('isShow')
                                    ? listMenuConfig.includes(value.isShow)
                                    : true;
                                if (value.permission && value.permission === true && isMenu) {
                                    return true;
                                }

                                return userPer.permission.includes(value.permission) && isMenu;
                            });
                            if (item.items.length !== 0) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            const isMenu = item.hasOwnProperty('isShow') ? listMenuConfig.includes(item.isShow) : true;
                            if (item.permission && item.permission === true && isMenu) {
                                return true;
                            }
                            return userPer.permission.includes(item.permission) && isMenu;
                        }
                    });
                    if (cate.items.length !== 0) {
                        listMenuAfterPermissionCheck.push(cate);
                    }
                } else {
                    const isMenu = cate.hasOwnProperty('isShow') ? listMenuConfig.includes(cate.isShow) : true;

                    if (userPer.permission.includes(cate.permission) && isMenu) {
                        listMenuAfterPermissionCheck.push(cate);
                    }
                }
                return cate;
            });
            // listMenuAfterPermissionCheck.push(mainMenuSp);
            // menu Sidebar Mobile
            setMenu(listMenuAfterPermissionCheck);
        }
    };
    useEffect(() => {
        handlePackage();
        getMenu();
        // eslint-disable-next-line
    }, [userPer, packageType, authData?.app, listMenuConfig]);

    return (
        <>
            <MenubarDemo
                setHeight={setHeight}
                menu={menu}
                visibleRight={visibleRight}
                setVisibleRight={setVisibleRight}
                userPer={userPer}
                dataSocket={dataSocket}
            />
            {visibleRequestSupport && (
                <RequestSupportDialog visible={visibleRequestSupport} onHideDialog={onHideDialogRequestSupport} />
            )}
        </>
    );
};

export default AppTopbar;
